import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  addArray as addUsersArray
} from 'store/redux/users'
import {
  refreshUsers,
  setUsersLoadStatus,
  setUsersCursor,
  addUsers as addUsersToUserGroup
} from 'store/redux/userGroups'

export default function * fetchUserGroupUsers (action) {
  const { id, refresh, keyword, cursor, limit = 20 } = action.payload

  let state = yield select()

  let userGroup = state.kanbo.userGroups[id]

  if (!userGroup) return

  if (refresh) {
    yield put(refreshUsers({
      id
    }))

    state = yield select()

    userGroup = state.kanbo.userGroups[id]
  }

  yield put(setUsersLoadStatus({
    id,
    loading: true,
    loaded: false
  }))

  const args = {
    limit,
    groupId: id
  }

  if (keyword) args.keyword = keyword
  if (cursor) args.cursor = cursor

  try {
    const { Users, Cursor } = yield call(apiGetData, 'UsersInGroup', args)

    const users = []
    const userIds = []

    Users.forEach(User => {
      const user = {
        id: User.Id,
        name: User.Name,
        email: User.Email,
        profileKey: User.ProfileKey,
        licenseType: User.LicenseType,
        isActive: User.Active,
        isLoaded: true,
        isLoading: false
      }

      users.push(user)
      userIds.push(user.id)
    })

    yield put([
      addUsersArray(users),
      addUsersToUserGroup({
        id,
        userIds
      }),
      setUsersLoadStatus({
        id,
        loading: false,
        loaded: !Cursor
      }),
      setUsersCursor({
        id,
        cursor: Cursor
      })
    ])
  } catch (error) {
    yield put(setUsersLoadStatus({
      id,
      loading: false,
      loaded: false
    }))

    throw error
  }
}
